export default __webpack_public_path__ + "static/media/gefion-hero.ecaca9ef.jpeg";